import logoBrandStarter from '../assets/logo_brandstarter.png';
import { useState, useRef, useEffect } from 'react';
import { api } from '../services/api';

// ─── STYLES GLOBAUX ────────────────────────────────────────────
export const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

  :root {
    --bs-green: #173B34;
    --bs-orange: #E4572E;
    --bs-cream: #F6F2EC;
    --bs-dark: #222222;
    --bs-green-light: rgba(23,59,52,0.07);
    --bs-orange-light: rgba(228,87,46,0.08);
    --bs-line: #EDE9E2;
  }

  .mp { font-family: 'Inter', sans-serif; color: var(--bs-dark); }

  /* PROGRESS BAR */
  .mp-progress { height: 3px; background: var(--bs-line); border-radius: 2px; margin-bottom: 32px; overflow: hidden; }
  .mp-progress-fill { height: 100%; background: linear-gradient(90deg, var(--bs-green), var(--bs-orange)); border-radius: 2px; transition: width .4s ease; }

  /* FORMATION */
  .mp-formation { max-width: 720px; margin: 0 auto; }
  .mp-part { margin-bottom: 48px; }
  .mp-part-num {
    display: inline-flex; align-items: center; gap: 8px;
    font-size: 10.5px; font-weight: 700; letter-spacing: .14em;
    text-transform: uppercase; color: var(--bs-orange);
    margin-bottom: 14px;
  }
  .mp-part-num::before { content: ''; width: 18px; height: 2px; background: var(--bs-orange); display: inline-block; }
  .mp-part h2 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(20px, 2.5vw, 26px);
    color: var(--bs-green); font-weight: 700;
    line-height: 1.2; margin-bottom: 14px;
  }
  .mp-part p { font-size: 15px; color: #555; line-height: 1.75; margin-bottom: 14px; font-weight: 300; }
  .mp-part strong { color: var(--bs-dark); font-weight: 600; }

  .mp-highlight {
    background: var(--bs-green-light); border-left: 3px solid var(--bs-green);
    border-radius: 0 12px 12px 0; padding: 16px 20px; margin: 18px 0;
    font-size: 14.5px; color: #333; line-height: 1.65;
  }
  .mp-highlight.orange {
    background: var(--bs-orange-light); border-left-color: var(--bs-orange);
  }
  .mp-stat {
    background: var(--bs-green); color: #fff;
    border-radius: 14px; padding: 20px 24px; margin: 20px 0;
    display: flex; align-items: center; gap: 16px;
  }
  .mp-stat-num {
    font-family: 'Playfair Display', serif;
    font-size: 40px; font-weight: 700; color: var(--bs-orange);
    flex-shrink: 0; line-height: 1;
  }
  .mp-stat-text { font-size: 14px; color: rgba(246,242,236,0.8); line-height: 1.55; }
  .mp-stat-text strong { color: #fff; display: block; font-size: 15px; margin-bottom: 3px; }

  .mp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin: 18px 0; }
  .mp-grid-item {
    background: #fff; border: 1px solid var(--bs-line);
    border-radius: 12px; padding: 16px 18px;
  }
  .mp-grid-item-ico { font-size: 20px; margin-bottom: 8px; }
  .mp-grid-item-title { font-size: 13.5px; font-weight: 700; color: var(--bs-green); margin-bottom: 5px; }
  .mp-grid-item-desc { font-size: 12.5px; color: #777; line-height: 1.55; }

  .mp-example {
    background: #fff; border: 1px solid var(--bs-line);
    border-radius: 14px; overflow: hidden; margin: 20px 0;
  }
  .mp-example-head {
    background: var(--bs-cream); padding: 12px 18px;
    font-size: 11px; font-weight: 700; color: #999;
    letter-spacing: .1em; text-transform: uppercase;
    border-bottom: 1px solid var(--bs-line);
  }
  .mp-example-body { padding: 18px; font-size: 14px; color: #444; line-height: 1.7; }

  .mp-vs { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin: 18px 0; }
  .mp-vs-bad { background: rgba(220,38,38,0.05); border: 1px solid rgba(220,38,38,0.2); border-radius: 12px; padding: 14px 16px; }
  .mp-vs-good { background: rgba(23,59,52,0.05); border: 1px solid rgba(23,59,52,0.2); border-radius: 12px; padding: 14px 16px; }
  .mp-vs-label { font-size: 10px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; margin-bottom: 8px; }
  .mp-vs-bad .mp-vs-label { color: #DC2626; }
  .mp-vs-good .mp-vs-label { color: var(--bs-green); }
  .mp-vs-text { font-size: 13px; line-height: 1.6; color: #444; font-style: italic; }

  .mp-framework {
    background: var(--bs-cream); border-radius: 14px; padding: 22px 24px; margin: 18px 0;
  }
  .mp-framework-title {
    font-family: 'Playfair Display', serif;
    font-size: 16px; font-weight: 700; color: var(--bs-green); margin-bottom: 16px;
  }
  .mp-fw-steps { display: flex; flex-direction: column; gap: 10px; }
  .mp-fw-step { display: flex; align-items: flex-start; gap: 12px; }
  .mp-fw-num {
    width: 28px; height: 28px; border-radius: 50%;
    border: 1.5px solid var(--bs-green);
    display: flex; align-items: center; justify-content: center;
    font-size: 12px; font-weight: 700; color: var(--bs-green);
    flex-shrink: 0; margin-top: 1px;
    font-family: 'Playfair Display', serif;
  }
  .mp-fw-content strong { display: block; font-size: 13.5px; color: var(--bs-dark); margin-bottom: 3px; }
  .mp-fw-content span { font-size: 12.5px; color: #777; line-height: 1.55; }

  /* CLARA SECTION */
  .mp-clara {
    display: flex; align-items: flex-start; gap: 14px;
    background: #fff; border: 1px solid var(--bs-line);
    border-radius: 14px; padding: 18px; margin: 20px 0;
  }
  .mp-clara-avatar {
    width: 40px; height: 40px; border-radius: 50%; background: var(--bs-green);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Playfair Display', serif; font-weight: 700; font-size: 16px;
    color: var(--bs-orange); flex-shrink: 0;
  }
  .mp-clara-bubble { flex: 1; }
  .mp-clara-name { font-size: 11px; font-weight: 700; color: var(--bs-green); letter-spacing: .06em; text-transform: uppercase; margin-bottom: 6px; }
  .mp-clara-text { font-size: 13.5px; color: #444; line-height: 1.65; font-style: italic; font-family: 'Playfair Display', serif; }

  /* QUIZ */
  .mp-quiz { max-width: 640px; margin: 0 auto; }
  .mp-quiz-q { background: #fff; border: 1px solid var(--bs-line); border-radius: 14px; padding: 22px 24px; margin-bottom: 16px; }
  .mp-quiz-q-text { font-size: 15px; font-weight: 600; color: var(--bs-dark); margin-bottom: 14px; line-height: 1.45; }
  .mp-quiz-options { display: flex; flex-direction: column; gap: 8px; }
  .mp-quiz-opt {
    padding: 11px 16px; border: 1.5px solid var(--bs-line);
    border-radius: 10px; cursor: pointer; font-size: 14px; color: #444;
    transition: all .15s; background: #FDFCFA;
  }
  .mp-quiz-opt:hover { border-color: var(--bs-green); background: var(--bs-green-light); color: var(--bs-green); }
  .mp-quiz-opt.selected { border-color: var(--bs-green); background: var(--bs-green-light); color: var(--bs-green); font-weight: 600; }
  .mp-quiz-opt.correct { border-color: #16A34A; background: rgba(22,163,74,0.08); color: #16A34A; font-weight: 600; }
  .mp-quiz-opt.wrong { border-color: #DC2626; background: rgba(220,38,38,0.05); color: #DC2626; }
  .mp-quiz-feedback { font-size: 13px; margin-top: 10px; padding: 10px 14px; border-radius: 8px; line-height: 1.55; }
  .mp-quiz-feedback.ok { background: rgba(22,163,74,0.08); color: #16A34A; }
  .mp-quiz-feedback.ko { background: rgba(220,38,38,0.05); color: #DC2626; }

  /* CONVERSATION */
  .mp-conv { display: flex; flex-direction: column; gap: 0; }
  .mp-step-indicator {
    text-align: center; font-size: 11px; font-weight: 700;
    letter-spacing: .1em; text-transform: uppercase;
    color: #BBB; margin-bottom: 20px;
  }
  .mp-step-dots { display: flex; justify-content: center; gap: 6px; margin-bottom: 8px; }
  .mp-step-dot {
    width: 8px; height: 8px; border-radius: 50%;
    background: var(--bs-line); transition: background .2s;
  }
  .mp-step-dot.done { background: var(--bs-green); }
  .mp-step-dot.active { background: var(--bs-orange); transform: scale(1.2); }

  .mp-block-title {
    font-size: 10px; font-weight: 700; letter-spacing: .14em;
    text-transform: uppercase; color: var(--bs-orange);
    text-align: center; margin-bottom: 16px;
    display: flex; align-items: center; gap: 8px;
  }
  .mp-block-title::before, .mp-block-title::after {
    content: ''; flex: 1; height: 1px; background: var(--bs-line);
  }

  .mp-messages { display: flex; flex-direction: column; gap: 14px; margin-bottom: 20px; }
  .mp-msg { display: flex; gap: 10px; align-items: flex-start; }
  .mp-msg.user { flex-direction: row-reverse; }
  .mp-msg-avatar {
    width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-size: 11px; font-weight: 700;
  }
  .mp-msg.clara .mp-msg-avatar { background: var(--bs-green); color: var(--bs-orange); font-family: 'Playfair Display', serif; font-size: 14px; }
  .mp-msg.user .mp-msg-avatar { background: var(--bs-orange); color: #fff; }
  .mp-msg-bubble {
    max-width: 78%; padding: 13px 16px;
    font-size: 14px; line-height: 1.65;
  }
  .mp-msg.clara .mp-msg-bubble {
    background: #fff; border: 1px solid var(--bs-line);
    border-radius: 16px 16px 16px 4px; color: #333;
  }
  .mp-msg.user .mp-msg-bubble {
    background: var(--bs-green); color: #F6F2EC;
    border-radius: 16px 16px 4px 16px;
  }

  .mp-input-wrap {
    display: flex; gap: 10px; align-items: flex-end;
    background: #fff; border: 1.5px solid var(--bs-line);
    border-radius: 14px; padding: 12px 16px;
    transition: border-color .15s;
  }
  .mp-input-wrap:focus-within { border-color: var(--bs-green); }
  .mp-input-wrap textarea {
    flex: 1; border: none; outline: none; resize: none;
    font-size: 14.5px; font-family: 'Inter', sans-serif;
    color: var(--bs-dark); line-height: 1.6; background: transparent;
    min-height: 44px; max-height: 140px;
  }
  .mp-input-wrap textarea::placeholder { color: #C0B8B0; }
  .mp-send-btn {
    background: var(--bs-green); color: #F6F2EC;
    border: none; border-radius: 10px; padding: 10px 18px;
    font-size: 13.5px; font-weight: 700; font-family: 'Inter', sans-serif;
    cursor: pointer; flex-shrink: 0; align-self: flex-end;
    transition: background .15s;
  }
  .mp-send-btn:hover { background: #0E2820; }
  .mp-send-btn:disabled { opacity: .4; cursor: not-allowed; }

  /* FICHE PERSONA */
  .fp2 {
    background: #fff; border-radius: 20px; overflow: hidden;
    box-shadow: 0 4px 6px rgba(23,59,52,0.04), 0 20px 40px rgba(23,59,52,0.10);
    margin-top: 20px;
    font-family: 'Inter', sans-serif;
  }
  .fp2-header {
    background: var(--bs-green); padding: 24px 28px;
    display: flex; align-items: center; justify-content: space-between;
    position: relative; overflow: hidden;
  }
  .fp2-header::before {
    content: ''; position: absolute; top: -50px; right: -50px;
    width: 180px; height: 180px; border-radius: 50%;
    background: rgba(228,87,46,0.1); pointer-events: none;
  }
  .fp2-avatar {
    width: 52px; height: 52px; border-radius: 50%; background: var(--bs-orange);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Playfair Display', serif; font-size: 20px; font-weight: 700;
    color: #fff; flex-shrink: 0; border: 2px solid rgba(255,255,255,0.2);
    position: relative; z-index: 2;
  }
  .fp2-header-info { position: relative; z-index: 2; }
  .fp2-name { font-family: 'Playfair Display', serif; font-size: 20px; font-weight: 700; color: #fff; margin-bottom: 3px; }
  .fp2-sub { font-size: 11px; color: rgba(246,242,236,0.45); letter-spacing: .08em; text-transform: uppercase; }
  .fp2-score-wrap { position: relative; z-index: 2; text-align: right; }
  .fp2-score-val { font-family: 'Playfair Display', serif; font-size: 32px; font-weight: 700; color: var(--bs-orange); line-height: 1; }
  .fp2-score-lbl { font-size: 9.5px; color: rgba(246,242,236,0.4); letter-spacing: .08em; text-transform: uppercase; margin-top: 2px; }
  .fp2-score-bar { width: 80px; height: 3px; background: rgba(255,255,255,0.1); border-radius: 2px; margin-top: 6px; margin-left: auto; overflow: hidden; }
  .fp2-score-fill { height: 100%; background: linear-gradient(90deg, var(--bs-orange), #FF8C5A); border-radius: 2px; }

  .fp2-citation {
    background: var(--bs-cream); border-left: 3px solid var(--bs-orange);
    padding: 15px 22px; display: flex; align-items: flex-start; gap: 10px;
  }
  .fp2-cite-ico { font-size: 18px; color: var(--bs-orange); flex-shrink: 0; font-family: Georgia; line-height: 1; margin-top: -2px; }
  .fp2-cite-text { font-size: 13.5px; color: #444; line-height: 1.65; font-style: italic; font-family: 'Playfair Display', serif; }

  .fp2-body { padding: 24px 28px; }
  .fp2-sec { font-size: 9.5px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: #B0A898; margin-bottom: 10px; display: flex; align-items: center; gap: 8px; }
  .fp2-sec::after { content: ''; flex: 1; height: 1px; background: var(--bs-line); }
  .fp2-grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 18px; }
  .fp2-grid3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; margin-bottom: 12px; }

  .fp2-profil { background: #FDFCFA; border: 1px solid var(--bs-line); border-radius: 12px; overflow: hidden; }
  .fp2-row { display: flex; justify-content: space-between; align-items: center; padding: 8px 13px; border-bottom: 1px solid var(--bs-line); font-size: 12.5px; }
  .fp2-row:last-child { border-bottom: none; }
  .fp2-rl { color: #AAA09A; }
  .fp2-rv { color: var(--bs-dark); font-weight: 600; }

  .fp2-stat { background: #FDFCFA; border: 1px solid var(--bs-line); border-radius: 10px; padding: 12px; text-align: center; }
  .fp2-stat-val { font-family: 'Playfair Display', serif; font-size: 18px; font-weight: 700; color: var(--bs-green); margin-bottom: 3px; }
  .fp2-stat-lbl { font-size: 9.5px; color: #AAA09A; letter-spacing: .04em; }

  .fp2-tags { display: flex; flex-wrap: wrap; gap: 5px; }
  .fp2-tag { font-size: 11.5px; padding: 4px 11px; border-radius: 999px; border: 1px solid var(--bs-line); background: #FDFCFA; color: #555; }
  .fp2-tag.green { background: var(--bs-green-light); border-color: rgba(23,59,52,0.2); color: var(--bs-green); font-weight: 600; }

  .fp2-emp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 18px; }
  .fp2-emp { background: #FDFCFA; border: 1px solid var(--bs-line); border-radius: 12px; padding: 13px 15px; }
  .fp2-emp-ico { font-size: 15px; margin-bottom: 5px; }
  .fp2-emp-title { font-size: 10px; font-weight: 700; color: var(--bs-green); letter-spacing: .06em; text-transform: uppercase; margin-bottom: 5px; }
  .fp2-emp-text { font-size: 12px; color: #555; line-height: 1.6; }

  .fp2-jtbd {
    background: linear-gradient(135deg, var(--bs-green), #1E4D44);
    border-radius: 12px; padding: 16px 20px; margin-bottom: 18px; color: #fff;
  }
  .fp2-jtbd-lbl { font-size: 9.5px; font-weight: 700; letter-spacing: .12em; color: rgba(246,242,236,0.4); text-transform: uppercase; margin-bottom: 7px; }
  .fp2-jtbd-text { font-family: 'Playfair Display', serif; font-size: 14px; font-style: italic; line-height: 1.6; color: #F6F2EC; }

  .fp2-dot-list { display: flex; flex-direction: column; gap: 7px; }
  .fp2-dot-item { display: flex; align-items: flex-start; gap: 9px; font-size: 13px; color: #444; line-height: 1.55; }
  .fp2-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; }

  .fp2-declencheur {
    background: rgba(228,87,46,0.06); border: 1px solid rgba(228,87,46,0.2);
    border-radius: 12px; padding: 14px 16px; margin-bottom: 18px;
  }

  .fp2-coh { background: #FDFCFA; border: 1px solid var(--bs-line); border-radius: 12px; overflow: hidden; }
  .fp2-coh-head { display: flex; justify-content: space-between; align-items: center; padding: 11px 15px; border-bottom: 1px solid var(--bs-line); background: var(--bs-cream); font-size: 12.5px; font-weight: 600; color: var(--bs-dark); }
  .fp2-coh-score { font-family: 'Playfair Display', serif; font-size: 15px; font-weight: 700; color: var(--bs-green); }
  .fp2-coh-item { display: flex; align-items: flex-start; gap: 10px; padding: 9px 15px; border-bottom: 1px solid var(--bs-line); font-size: 12.5px; color: #444; line-height: 1.5; }
  .fp2-coh-item:last-child { border-bottom: none; }

  .fp2-footer {
    display: flex; justify-content: space-between; align-items: center;
    padding: 14px 28px; border-top: 1px solid var(--bs-line); background: #FDFCFA;
  }
  .fp2-logo-wrap { display: flex; align-items: center; gap: 8px; }
  .fp2-logo { height: 24px; width: auto; }
  .fp2-footer-txt { font-size: 10.5px; color: #C0B8B0; }
  .fp2-dl-btn {
    background: var(--bs-green); color: #F6F2EC;
    border: none; border-radius: 999px; padding: 9px 20px;
    font-size: 12.5px; font-weight: 700; cursor: pointer;
    font-family: 'Inter', sans-serif; display: flex; align-items: center; gap: 7px;
  }

  /* BOUTONS NAVIGATION */
  .mp-nav-btns { display: flex; justify-content: space-between; align-items: center; margin-top: 32px; gap: 12px; }
  .mp-btn-primary {
    background: var(--bs-green); color: #F6F2EC;
    border: none; border-radius: 999px; padding: 13px 28px;
    font-size: 14.5px; font-weight: 700; cursor: pointer;
    font-family: 'Inter', sans-serif; display: flex; align-items: center; gap: 8px;
    box-shadow: 0 4px 14px rgba(23,59,52,0.25);
    transition: all .15s;
  }
  .mp-btn-primary:hover { background: #0E2820; transform: translateY(-1px); }
  .mp-btn-primary:disabled { opacity: .4; cursor: not-allowed; transform: none; }
  .mp-btn-secondary {
    background: transparent; color: var(--bs-green);
    border: 1.5px solid var(--bs-line); border-radius: 999px; padding: 12px 24px;
    font-size: 14px; font-weight: 600; cursor: pointer; font-family: 'Inter', sans-serif;
  }
  .mp-btn-secondary:hover { border-color: var(--bs-green); }

  @media(max-width:640px) {
    .fp2-grid2 { grid-template-columns: 1fr; }
    .fp2-emp-grid { grid-template-columns: 1fr; }
    .mp-vs { grid-template-columns: 1fr; }
    .mp-grid { grid-template-columns: 1fr; }
  }
`;

// ─── DONNÉES ─────────────────────────────────────────────────
const FORMATION = [
  {
    num: 'Partie 1',
    titre: "L'erreur que font 90% des créateurs",
    content: () => (
      <>
        <p>Quand on lance son activité, la tentation est forte de s'adresser à tout le monde. <strong>C'est l'erreur la plus courante, et la plus coûteuse.</strong></p>
        <div className="mp-highlight orange">
          Une communication qui parle à tout le monde ne touche personne. Un message générique produit des résultats génériques.
        </div>
        <p>Les créateurs qui attirent les bons clients ont tous un point commun : ils savent exactement à qui ils s'adressent. Pas une tranche d'âge. Pas un secteur. Une <strong>personne précise, avec une vie, des frustrations et des rêves concrets.</strong></p>
        <div className="mp-stat">
          <div className="mp-stat-num">73%</div>
          <div className="mp-stat-text">
            <strong>de taux de conversion en plus</strong>
            pour les entreprises avec un persona bien défini, selon une étude HubSpot (2024). Ce n'est pas du marketing théorique, c'est de l'argent.
          </div>
        </div>
        <p>Le persona, c'est l'outil qui te force à sortir de ta tête pour entrer dans celle de ton client. Et tout change à partir de là.</p>
      </>
    )
  },
  {
    num: 'Partie 2',
    titre: 'Ce qui se passe dans la tête de ton client avant d\'acheter',
    content: () => (
      <>
        <p>Avant de sortir sa carte bancaire, ton client traverse un chemin mental précis. Il <strong>ressent</strong> une douleur. Il <strong>imagine</strong> une transformation. Il <strong>hésite</strong> à cause d'objections. Puis quelque chose le <strong>déclenche.</strong></p>
        <div className="mp-framework">
          <div className="mp-framework-title">Les 3 frameworks que tu vas utiliser</div>
          <div className="mp-fw-steps">
            <div className="mp-fw-step">
              <div className="mp-fw-num">1</div>
              <div className="mp-fw-content">
                <strong>Le Persona, Qui est-il vraiment ?</strong>
                <span>Profil, vie quotidienne, niveau de revenus, mode de vie. La base démographique et comportementale.</span>
              </div>
            </div>
            <div className="mp-fw-step">
              <div className="mp-fw-num">2</div>
              <div className="mp-fw-content">
                <strong>La Carte d'Empathie, Ce qu'il ressent</strong>
                <span>Ce qu'il pense, entend, voit, dit et fait. Le modèle de Dave Gray pour aller au-delà des données démographiques.</span>
              </div>
            </div>
            <div className="mp-fw-step">
              <div className="mp-fw-num">3</div>
              <div className="mp-fw-content">
                <strong>Le JTBD, Pourquoi il achète</strong>
                <span>"Jobs to be Done" : ton client n'achète pas ton service, il "embauche" une solution pour accomplir un job dans sa vie. Comprendre ce job change tout.</span>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  },
  {
    num: 'Partie 3',
    titre: 'Un persona concret : Thomas, consultant indépendant',
    content: () => (
      <>
        <p>Voici comment ces 3 frameworks s'appliquent sur un cas réel. Suis Thomas à travers les 3 dimensions.</p>
        <div className="mp-example">
          <div className="mp-example-head">🧠 Persona, Qui est Thomas ?</div>
          <div className="mp-example-body">Thomas, 34 ans, consultant en transformation digitale indépendant depuis 2 ans. Marié, 1 enfant. Vit à Lille. Revenu actuel : 3 500€/mois, mais irrégulier. Il travaille depuis son domicile, jongle entre missions et prospection. Suit des podcasts business, actif sur LinkedIn.</div>
        </div>
        <div className="mp-example">
          <div className="mp-example-head">🗺️ Carte d'Empathie, Ce que ressent Thomas</div>
          <div className="mp-example-body">
            <strong>Il pense :</strong> "Je suis bon dans ce que je fais, mais personne ne le sait."<br/>
            <strong>Il entend :</strong> Ses clients potentiels comparer avec des grandes agences.<br/>
            <strong>Il voit :</strong> Des concurrents moins compétents mieux positionnés que lui en ligne.<br/>
            <strong>Il dit :</strong> "Je suis consultant", mais sans conviction dans la voix.
          </div>
        </div>
        <div className="mp-example">
          <div className="mp-example-head">🎯 JTBD, Le job que Thomas veut accomplir</div>
          <div className="mp-example-body">"Quand je prospecte un nouveau client, je veux avoir un positionnement si clair et une image si professionnelle que le prospect comprend immédiatement ma valeur, pour qu'il me choisisse moi sans comparer les prix."</div>
        </div>
      </>
    )
  },
  {
    num: 'Partie 4',
    titre: 'Les 5 erreurs qui rendent un persona inutile',
    content: () => (
      <>
        <div className="mp-grid">
          {[
            { ico: '🌍', t: 'Trop large', d: '"Femmes entre 25 et 55 ans", ça ne sert à rien. Plus ta cible est précise, plus ton message est efficace.' },
            { ico: '🪞', t: 'Se projeter soi-même', d: 'Tu n\'es pas ton client. Ses préférences, ses frustrations, ses mots ne sont pas les tiens.' },
            { ico: '🎭', t: 'L\'inventer de toutes pièces', d: 'Un persona basé sur des suppositions reste une supposition. Il doit reposer sur des observations réelles.' },
            { ico: '🗂️', t: 'Ne jamais le mettre à jour', d: 'Ton marché évolue. Ton persona aussi. Une révision tous les 6-12 mois est indispensable.' },
            { ico: '🚫', t: 'Ignorer les objections', d: 'Les raisons de NE PAS acheter sont aussi importantes que les motivations d\'achat. Souvent plus.' },
          ].map((e, i) => (
            <div key={i} className="mp-grid-item">
              <div className="mp-grid-item-ico">{e.ico}</div>
              <div className="mp-grid-item-title">{e.t}</div>
              <div className="mp-grid-item-desc">{e.d}</div>
            </div>
          ))}
        </div>
      </>
    )
  },
  {
    num: 'Partie 5',
    titre: 'Comment répondre à Clara pour obtenir une fiche béton',
    content: () => (
      <>
        <p>Clara va te poser <strong>10 questions</strong> réparties en 3 blocs. La qualité de tes réponses détermine directement la qualité de ta fiche persona.</p>
        <div className="mp-clara">
          <div className="mp-clara-avatar">C</div>
          <div className="mp-clara-bubble">
            <div className="mp-clara-name">Clara · Guide BrandStarter</div>
            <div className="mp-clara-text">Je vais être directe avec toi : si tu réponds "entrepreneur de 30-50 ans", je vais te le dire. Ce n'est pas utilisable. La précision de tes réponses, c'est ce qui fait la différence entre une fiche persona que tu mets dans un tiroir et une fiche que tu utilises tous les jours.</div>
          </div>
        </div>
        <p style={{marginTop: 16}}>Voici la différence entre une mauvaise et une bonne réponse :</p>
        <div className="mp-vs">
          <div className="mp-vs-bad">
            <div className="mp-vs-label">❌ Réponse inutilisable</div>
            <div className="mp-vs-text">"Sa frustration principale, c'est le manque de temps."</div>
          </div>
          <div className="mp-vs-good">
            <div className="mp-vs-label">✅ Réponse exploitable</div>
            <div className="mp-vs-text">"Le dimanche soir, il stresse parce qu'il a encore passé une semaine sans décrocher un nouveau client malgré 3h de prospection sur LinkedIn."</div>
          </div>
        </div>
        <div className="mp-vs">
          <div className="mp-vs-bad">
            <div className="mp-vs-label">❌ Réponse inutilisable</div>
            <div className="mp-vs-text">"Il veut développer son business."</div>
          </div>
          <div className="mp-vs-good">
            <div className="mp-vs-label">✅ Réponse exploitable</div>
            <div className="mp-vs-text">"Il veut décrocher 2 clients à 2 000€/mois d'ici 90 jours pour pouvoir quitter son emploi salarié."</div>
          </div>
        </div>
        <div className="mp-highlight">
          <strong>La règle d'or :</strong> si ta réponse pourrait s'appliquer à n'importe quel entrepreneur, recommence. Un bon persona est si précis qu'on pourrait reconnaître cette personne dans la vraie vie.
        </div>
      </>
    )
  }
];

const QUIZ = [
  {
    q: "Quelle est la principale erreur dans la définition d'une cible ?",
    opts: [
      "Choisir une cible trop jeune",
      "S'adresser à tout le monde sans précision",
      "Cibler uniquement les femmes",
      "Ne pas inclure les réseaux sociaux"
    ],
    correct: 1,
    feedback: "Exact. Parler à tout le monde, c'est ne toucher personne. Un message précis pour une personne précise est toujours plus efficace."
  },
  {
    q: "Que signifie JTBD (Jobs to Be Done) ?",
    opts: [
      "Un outil de gestion de projet marketing",
      "Les tâches à accomplir pour créer un persona",
      "Le job qu'un client 'embauche' ton service pour accomplir dans sa vie",
      "Un framework de création de contenu"
    ],
    correct: 2,
    feedback: "Exactement. Ton client n'achète pas ton service, il embauche une solution pour accomplir quelque chose de précis dans sa vie."
  },
  {
    q: "Parmi ces réponses, laquelle est exploitable pour décrire la frustration d'un persona ?",
    opts: [
      "Il manque de temps.",
      "Il veut plus de clients.",
      "Le dimanche soir, il stresse car il a encore passé une semaine sans décrocher un nouveau contrat.",
      "Il n'est pas satisfait de ses résultats."
    ],
    correct: 2,
    feedback: "Précis, ancré dans une situation réelle, avec une émotion. C'est exactement ce niveau de détail qui rend un persona utilisable au quotidien."
  },
  {
    q: "Qu'est-ce que la carte d'empathie ajoute au persona classique ?",
    opts: [
      "Des données chiffrées supplémentaires",
      "Une analyse de ce que le persona pense, ressent, entend et voit",
      "La liste de ses réseaux sociaux préférés",
      "Son niveau de revenus précis"
    ],
    correct: 1,
    feedback: "La carte d'empathie va au-delà des données démographiques pour comprendre la psychologie profonde de ton client."
  }
];

const QUESTIONS_CONV = [
  { bloc: 'Portrait humain', q: "Commence par donner un prénom à ton client idéal. Un vrai prénom, ça aide à le rendre réel et à ne plus parler d'une statistique." },
  { bloc: 'Portrait humain', q: (prenom) => `Qui est ${prenom} ? Décris-moi son âge, sa situation familiale, son métier et où il vit. Sois précis : pas "entrepreneur entre 30 et 50 ans", une vraie personne.` },
  { bloc: 'Portrait humain', q: (prenom) => `Décris la journée professionnelle type de ${prenom}. Comment il travaille, ce qu'il fait concrètement, à quoi ressemble son quotidien.` },
  { bloc: "Psychologie & carte d'empathie", q: (prenom) => `Quelle est la pensée qui revient le plus souvent à ${prenom} en ce moment par rapport à son activité ? Sa peur, son blocage, ce qui l'empêche de dormir.` },
  { bloc: "Psychologie & carte d'empathie", q: (prenom) => `Qu'est-ce que l'entourage de ${prenom} lui dit ? Ses collègues, ses proches, les personnes qu'il suit en ligne, qu'est-ce qu'il entend autour de lui ?` },
  { bloc: "Psychologie & carte d'empathie", q: (prenom) => `Quand ${prenom} regarde ses concurrents ou ses pairs qui réussissent, qu'est-ce qu'il observe ? Qu'est-ce qui le frustre ou l'inspire ?` },
  { bloc: 'Déclencheur & JTBD', q: (prenom) => `Quel est le résultat concret que ${prenom} veut obtenir ? Pas "il veut ton service", le vrai résultat dans sa vie ou son business dans 90 jours.` },
  { bloc: 'Déclencheur & JTBD', q: (prenom) => `Pourquoi ${prenom} n'a pas encore résolu ce problème ? Qu'est-ce qui l'en a empêché jusqu'ici ?` },
  { bloc: 'Déclencheur & JTBD', q: (prenom) => `Qu'est-ce que ${prenom} se dirait pour ne PAS acheter chez toi ? Prix, timing, confiance, priorité, donne-moi ses vraies objections.` },
  { bloc: 'Déclencheur & JTBD', q: (prenom) => `Quel événement ou quelle prise de conscience pourrait faire passer ${prenom} à l'action demain matin ? Qu'est-ce qui serait le déclic ?` },
];

// ─── PARSER FICHE PERSONA ─────────────────────────────────────
function parseFichePersona(synthese) {
  if (!synthese) return null;
  const r = {
    prenom:'', age:'', situation:'', etudes:'', metier:'', lieu:'', revenu:'',
    budget:'', horizon:'', dispo:'', canaux:[], frustrations:[], objectifs:[],
    defis:[], kpis:[], citation:'', declencheurs:[], score:0,
    coherenceOk:[], coherenceWarn:[], coherenceErr:[],
    empathie_pense:'', empathie_entend:'', empathie_voit:'', empathie_dit:'',
    jtbd:'', objections:[], declencheur_achat:'', synthese:''
  };
  try {
    const keys = ['PERSONA_PRENOM','PERSONA_AGE','PERSONA_SITUATION','PERSONA_ETUDES',
      'PERSONA_METIER','PERSONA_LIEU','PERSONA_REVENU','PERSONA_BUDGET','PERSONA_HORIZON',
      'PERSONA_DISPO','PERSONA_CANAUX','PERSONA_FRUSTRATIONS','PERSONA_OBJECTIFS',
      'PERSONA_DEFIS','PERSONA_KPIS','PERSONA_CITATION','PERSONA_DECLENCHEURS',
      'PERSONA_OBJECTIONS','PERSONA_JTBD','PERSONA_DECLENCHEUR_ACHAT',
      'EMPATHIE_PENSE','EMPATHIE_ENTEND','EMPATHIE_VOIT','EMPATHIE_DIT',
      'COHERENCE_SCORE','COHERENCE_OK','COHERENCE_WARN','COHERENCE_ERR','SYNTHESE'];
    let normalized = synthese;
    keys.forEach(k => {
      normalized = normalized.replace(new RegExp('\\s+' + k + ':', 'g'), '\n' + k + ':');
    });
    const lines = normalized.split('\n');
    lines.forEach(line => {
      const t = line.trim();
      const get = (k) => t.startsWith(k) ? t.slice(k.length).trim() : null;
      const arr = (k) => { const v = get(k); return v ? v.split('|').map(x=>x.trim()).filter(Boolean) : null; };
      if (get('PERSONA_PRENOM:')) r.prenom = get('PERSONA_PRENOM:');
      if (get('PERSONA_AGE:')) r.age = get('PERSONA_AGE:');
      if (get('PERSONA_SITUATION:')) r.situation = get('PERSONA_SITUATION:');
      if (get('PERSONA_ETUDES:')) r.etudes = get('PERSONA_ETUDES:');
      if (get('PERSONA_METIER:')) r.metier = get('PERSONA_METIER:');
      if (get('PERSONA_LIEU:')) r.lieu = get('PERSONA_LIEU:');
      if (get('PERSONA_REVENU:')) r.revenu = get('PERSONA_REVENU:');
      if (get('PERSONA_BUDGET:')) r.budget = get('PERSONA_BUDGET:');
      if (get('PERSONA_HORIZON:')) r.horizon = get('PERSONA_HORIZON:');
      if (get('PERSONA_DISPO:')) r.dispo = get('PERSONA_DISPO:');
      if (get('PERSONA_CANAUX:')) r.canaux = get('PERSONA_CANAUX:').split(/[,|]/).map(x=>x.trim()).filter(Boolean);
      if (arr('PERSONA_FRUSTRATIONS:')) r.frustrations = arr('PERSONA_FRUSTRATIONS:');
      if (arr('PERSONA_OBJECTIFS:')) r.objectifs = arr('PERSONA_OBJECTIFS:');
      if (arr('PERSONA_DEFIS:')) r.defis = arr('PERSONA_DEFIS:');
      if (arr('PERSONA_KPIS:')) r.kpis = arr('PERSONA_KPIS:');
      if (arr('PERSONA_OBJECTIONS:')) r.objections = arr('PERSONA_OBJECTIONS:');
      if (arr('PERSONA_DECLENCHEURS:')) r.declencheurs = arr('PERSONA_DECLENCHEURS:');
      if (get('PERSONA_CITATION:')) r.citation = get('PERSONA_CITATION:').replace(/^[""]|[""]$/g,'');
      if (get('PERSONA_JTBD:')) r.jtbd = get('PERSONA_JTBD:');
      if (get('PERSONA_DECLENCHEUR_ACHAT:')) r.declencheur_achat = get('PERSONA_DECLENCHEUR_ACHAT:');
      if (get('EMPATHIE_PENSE:')) r.empathie_pense = get('EMPATHIE_PENSE:');
      if (get('EMPATHIE_ENTEND:')) r.empathie_entend = get('EMPATHIE_ENTEND:');
      if (get('EMPATHIE_VOIT:')) r.empathie_voit = get('EMPATHIE_VOIT:');
      if (get('EMPATHIE_DIT:')) r.empathie_dit = get('EMPATHIE_DIT:');
      if (get('COHERENCE_SCORE:')) r.score = parseInt(get('COHERENCE_SCORE:')) || 0;
      if (arr('COHERENCE_OK:')) r.coherenceOk = arr('COHERENCE_OK:');
      if (arr('COHERENCE_WARN:')) r.coherenceWarn = arr('COHERENCE_WARN:');
      if (arr('COHERENCE_ERR:')) r.coherenceErr = arr('COHERENCE_ERR:');
      if (get('SYNTHESE:')) r.synthese = get('SYNTHESE:');
    });
  } catch(e) {}
  return r.prenom || r.age ? r : null;
}

// ─── FICHE PERSONA V2 ─────────────────────────────────────────
function FichePersonaV2({ synthese }) {
  const ficheRef = useRef(null);
  const data = parseFichePersona(synthese);
  if (!data) return null;

  const initiales = data.prenom
    ? data.prenom.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2)
    : 'PC';

  const handleDownload = () => {
    const el = ficheRef.current;
    if (!el) return;
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
    document.head.appendChild(script);
    script.onload = () => {
      window.html2canvas(el, { scale: 2, useCORS: true, backgroundColor: '#ffffff' }).then(canvas => {
        const link = document.createElement('a');
        link.download = `persona-${(data.prenom||'client').toLowerCase().replace(/\s+/g,'-')}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
      });
    };
  };

  return (
    <div ref={ficheRef} className="fp2">
      {/* HEADER */}
      <div className="fp2-header">
        <div style={{display:'flex',alignItems:'center',gap:14,position:'relative',zIndex:2}}>
          <div className="fp2-avatar">{initiales}</div>
          <div className="fp2-header-info">
            <div className="fp2-name">{data.prenom || 'Persona client'}</div>
            <div className="fp2-sub">Persona client idéal · Module 02</div>
          </div>
        </div>
        {data.score > 0 && (
          <div className="fp2-score-wrap">
            <div className="fp2-score-val">{data.score}</div>
            <div className="fp2-score-lbl">Score de précision</div>
            <div className="fp2-score-bar">
              <div className="fp2-score-fill" style={{width:`${data.score}%`}}></div>
            </div>
          </div>
        )}
      </div>

      {/* CITATION */}
      {data.citation && (
        <div className="fp2-citation">
          <div className="fp2-cite-ico">"</div>
          <div className="fp2-cite-text">{data.citation}</div>
        </div>
      )}

      <div className="fp2-body">

        {/* PROFIL + STATS */}
        <div className="fp2-grid2">
          <div>
            <div className="fp2-sec">Profil</div>
            <div className="fp2-profil">
              {data.age && <div className="fp2-row"><span className="fp2-rl">Âge</span><span className="fp2-rv">{data.age}</span></div>}
              {data.situation && <div className="fp2-row"><span className="fp2-rl">Situation</span><span className="fp2-rv">{data.situation}</span></div>}
              {data.metier && <div className="fp2-row"><span className="fp2-rl">Métier</span><span className="fp2-rv">{data.metier}</span></div>}
              {data.lieu && <div className="fp2-row"><span className="fp2-rl">Lieu</span><span className="fp2-rv">{data.lieu}</span></div>}
              {data.revenu && <div className="fp2-row"><span className="fp2-rl">Revenu</span><span className="fp2-rv">{data.revenu}</span></div>}
            </div>
          </div>
          <div>
            <div className="fp2-sec">Données clés</div>
            <div className="fp2-grid3" style={{marginBottom:12}}>
              <div className="fp2-stat"><div className="fp2-stat-val">{data.budget||'N/A'}</div><div className="fp2-stat-lbl">Budget max</div></div>
              <div className="fp2-stat"><div className="fp2-stat-val">{data.horizon||'N/A'}</div><div className="fp2-stat-lbl">Horizon</div></div>
              <div className="fp2-stat"><div className="fp2-stat-val">{data.dispo||'N/A'}</div><div className="fp2-stat-lbl">Dispo/sem</div></div>
            </div>
            {data.canaux.length > 0 && <>
              <div className="fp2-sec">Canaux</div>
              <div className="fp2-tags">{data.canaux.map((c,i) => <span key={i} className="fp2-tag green">{c}</span>)}</div>
            </>}
          </div>
        </div>

        {/* CARTE D'EMPATHIE */}
        {(data.empathie_pense || data.empathie_entend || data.empathie_voit || data.empathie_dit) && <>
          <div className="fp2-sec">Carte d'empathie</div>
          <div className="fp2-emp-grid">
            {data.empathie_pense && <div className="fp2-emp"><div className="fp2-emp-ico">🧠</div><div className="fp2-emp-title">Ce qu'il pense</div><div className="fp2-emp-text">{data.empathie_pense}</div></div>}
            {data.empathie_entend && <div className="fp2-emp"><div className="fp2-emp-ico">👂</div><div className="fp2-emp-title">Ce qu'il entend</div><div className="fp2-emp-text">{data.empathie_entend}</div></div>}
            {data.empathie_voit && <div className="fp2-emp"><div className="fp2-emp-ico">👀</div><div className="fp2-emp-title">Ce qu'il voit</div><div className="fp2-emp-text">{data.empathie_voit}</div></div>}
            {data.empathie_dit && <div className="fp2-emp"><div className="fp2-emp-ico">💬</div><div className="fp2-emp-title">Ce qu'il dit</div><div className="fp2-emp-text">{data.empathie_dit}</div></div>}
          </div>
        </>}

        {/* JTBD */}
        {data.jtbd && <>
          <div className="fp2-sec">Job à accomplir</div>
          <div className="fp2-jtbd">
            <div className="fp2-jtbd-lbl">Quand... il veut... pour...</div>
            <div className="fp2-jtbd-text">{data.jtbd}</div>
          </div>
        </>}

        {/* FRUSTRATIONS + OBJECTIFS */}
        {(data.frustrations.length > 0 || data.objectifs.length > 0) && (
          <div className="fp2-grid2" style={{marginBottom:18}}>
            {data.frustrations.length > 0 && <div>
              <div className="fp2-sec">Frustrations</div>
              <div className="fp2-dot-list">{data.frustrations.map((f,i) => <div key={i} className="fp2-dot-item"><div className="fp2-dot" style={{background:'#E4572E'}}></div>{f}</div>)}</div>
            </div>}
            {data.objectifs.length > 0 && <div>
              <div className="fp2-sec">Objectifs</div>
              <div className="fp2-dot-list">{data.objectifs.map((o,i) => <div key={i} className="fp2-dot-item"><div className="fp2-dot" style={{background:'#173B34'}}></div>{o}</div>)}</div>
            </div>}
          </div>
        )}

        {/* OBJECTIONS */}
        {data.objections.length > 0 && <>
          <div className="fp2-sec">Objections d'achat</div>
          <div className="fp2-dot-list" style={{marginBottom:18}}>
            {data.objections.map((o,i) => <div key={i} className="fp2-dot-item"><div className="fp2-dot" style={{background:'#DC2626'}}></div>{o}</div>)}
          </div>
        </>}

        {/* DECLENCHEUR */}
        {data.declencheur_achat && <>
          <div className="fp2-declencheur">
            <div className="fp2-sec" style={{color:'#E4572E'}}>Déclencheur d'achat</div>
            <div style={{fontSize:13.5,color:'#444',lineHeight:1.65}}>{data.declencheur_achat}</div>
          </div>
        </>}

        {/* COHERENCE */}
        {(data.coherenceOk.length > 0 || data.coherenceWarn.length > 0 || data.coherenceErr.length > 0) && <>
          <div className="fp2-sec">Analyse Clara</div>
          <div className="fp2-coh">
            <div className="fp2-coh-head">
              <span>Vérification de cohérence</span>
              <span className="fp2-coh-score">{data.score}/100</span>
            </div>
            {data.coherenceOk.map((t,i) => <div key={i} className="fp2-coh-item"><span style={{color:'#16A34A',flexShrink:0}}>✅</span>{t}</div>)}
            {data.coherenceWarn.map((t,i) => <div key={i} className="fp2-coh-item"><span style={{color:'#D97706',flexShrink:0}}>⚠️</span>{t}</div>)}
            {data.coherenceErr.map((t,i) => <div key={i} className="fp2-coh-item"><span style={{color:'#DC2626',flexShrink:0}}>✗</span>{t}</div>)}
          </div>
        </>}

      </div>

      {/* FOOTER */}
      <div className="fp2-footer">
        <div className="fp2-logo-wrap">
          <img src={logoBrandStarter} alt="BrandStarter" className="fp2-logo" />
          <span className="fp2-footer-txt">Module 02 · Persona client</span>
        </div>
        <button className="fp2-dl-btn" onClick={handleDownload}>
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M8 2v8M5 7l3 3 3-3M3 13h10" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Télécharger PNG
        </button>
      </div>
    </div>
  );
}

// ─── COMPOSANT PRINCIPAL ──────────────────────────────────────
export function ModulePersona({ moduleValide, syntheseExistante, onValidate, contextePrecedent }) {
  const [phase, setPhase] = useState(moduleValide ? 'done' : 'formation');
  const [formationStep, setFormationStep] = useState(0);
  const [quizAnswers, setQuizAnswers] = useState({});
  const [quizSubmitted, setQuizSubmitted] = useState(false);
  const [quizOk, setQuizOk] = useState(false);
  const [convMessages, setConvMessages] = useState([]);
  const [convInput, setConvInput] = useState('');
  const [convLoading, setConvLoading] = useState(false);
  const [convStep, setConvStep] = useState(0);
  const [prenom, setPrenom] = useState('');
  const [synthese, setSynthese] = useState(syntheseExistante || '');
  const [error, setError] = useState('');
  const chatEndRef = useRef(null);

  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [convMessages]);

  // Init conversation
  useEffect(() => {
    if (phase === 'conversation' && convMessages.length === 0) {
      setConvMessages([{
        role: 'assistant',
        content: QUESTIONS_CONV[0].q
      }]);
    }
  }, [phase]);

  const totalSteps = FORMATION.length;
  const progress = phase === 'formation'
    ? ((formationStep + 1) / (totalSteps + 2)) * 100
    : phase === 'quiz' ? ((totalSteps + 1) / (totalSteps + 2)) * 100
    : phase === 'conversation' ? ((totalSteps + 1.5) / (totalSteps + 2)) * 100
    : 100;

  // QUIZ
  const submitQuiz = () => {
    const allAnswered = QUIZ.every((_, i) => quizAnswers[i] !== undefined);
    if (!allAnswered) { setError('Réponds à toutes les questions avant de continuer.'); return; }
    setQuizSubmitted(true);
    const allCorrect = QUIZ.every((q, i) => quizAnswers[i] === q.correct);
    setQuizOk(allCorrect);
    setError('');
  };

  const retryQuiz = () => {
    setQuizAnswers({});
    setQuizSubmitted(false);
    setQuizOk(false);
  };

  // CONVERSATION
  const sendConvMessage = async () => {
    if (!convInput.trim() || convLoading) return;
    const userMsg = { role: 'user', content: convInput.trim() };
    const newMsgs = [...convMessages, userMsg];
    setConvMessages(newMsgs);
    const userInput = convInput.trim();
    setConvInput('');
    setConvLoading(true);
    setError('');

    // Capturer le prénom à l'étape 0
    if (convStep === 0) {
      const words = userInput.split(' ');
      const p = words[0] ? words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase() : userInput;
      setPrenom(p);
    }

    const currentPrenom = convStep === 0
      ? (userInput.split(' ')[0] || userInput)
      : prenom;

    try {
      const nextStep = convStep + 1;

      if (nextStep < QUESTIONS_CONV.length) {
        // Appel IA pour challenge + question suivante
        const prompt = buildChallengePrompt(convStep, userInput, currentPrenom, newMsgs, nextStep);
        const res = await api.chatIA(2, {
          conversation: [{ role: 'user', content: prompt }],
          tourActuel: convStep,
          contextePrecedent
        });
        setConvMessages(prev => [...prev, { role: 'assistant', content: res.message }]);
        setConvStep(nextStep);
        if (nextStep === 0) setPrenom(userInput.split(' ')[0] || userInput);
      } else {
        // Dernière question : générer la synthèse complète
        const prompt = buildSynthesePrompt(newMsgs, currentPrenom);
        const res = await api.chatIA(2, {
          conversation: [{ role: 'user', content: prompt }],
          tourActuel: 10,
          contextePrecedent
        });
        const msg = res.message;
        setConvMessages(prev => [...prev, { role: 'assistant', content: "Parfait. J'ai tout ce qu'il me faut pour construire ta fiche persona. Voici le résultat..." }]);
        setSynthese(msg);
        setPhase('done');
      }
    } catch(e) {
      setError(e.message);
    } finally {
      setConvLoading(false);
    }
  };

  const buildChallengePrompt = (step, answer, pren, msgs, nextStep) => {
    const nextQ = QUESTIONS_CONV[nextStep];
    const nextQText = typeof nextQ.q === 'function' ? nextQ.q(pren) : nextQ.q;
    const blocs = ['BLOC 1, PORTRAIT HUMAIN','BLOC 1, PORTRAIT HUMAIN','BLOC 1, PORTRAIT HUMAIN','BLOC 2, CARTE EMPATHIE','BLOC 2, CARTE EMPATHIE','BLOC 2, CARTE EMPATHIE','BLOC 3, DÉCLENCHEUR JTBD','BLOC 3, DÉCLENCHEUR JTBD','BLOC 3, DÉCLENCHEUR JTBD','BLOC 3, DÉCLENCHEUR JTBD'];
    const blocChange = nextStep === 3 || nextStep === 6;
    return `Tu es Clara, guide IA de BrandStarter. Tu construis le persona client idéal de l'utilisateur via 10 questions structurées.

ÉTAPE ACTUELLE : ${step + 1}/10
RÉPONSE DE L'UTILISATEUR : "${answer}"
PRÉNOM DU PERSONA : ${pren}
${blocChange ? `\nTU PASSES AU ${blocs[nextStep]}. Annonce ce changement de manière fluide.\n` : ''}

TON RÔLE :
1. Réagis à la réponse (en 1-2 phrases max). Si elle est trop vague, challenge avec bienveillance et un exemple. Si elle est précise, valide chaleureusement.
2. Pose la question suivante : "${nextQText}"

RÈGLES STRICTES :
- Tutoiement obligatoire
- Jamais de tiret "—", utilise ":" ou une virgule
- Si la réponse est clichée ("manque de temps", "veut plus de clients"), demande de creuser
- Reste fluide et encourageant, comme un coach bienveillant mais exigeant
- Maximum 4 lignes au total dans ta réponse`;
  };

  const buildSynthesePrompt = (msgs, pren) => {
    const userAnswers = msgs.filter(m => m.role === 'user').map((m, i) => `Q${i+1}: ${m.content}`).join('\n');
    return `Tu es Clara, guide IA de BrandStarter. À partir des 10 réponses de l'utilisateur, génère une fiche persona complète et structurée.

PRÉNOM DU PERSONA : ${pren}
RÉPONSES COLLECTÉES :
${userAnswers}

Génère la fiche persona EXACTEMENT dans ce format (une clé par ligne) :

PERSONA_PRENOM: [prénom exact donné]
PERSONA_AGE: [âge ou tranche]
PERSONA_SITUATION: [situation familiale]
PERSONA_METIER: [métier précis]
PERSONA_LIEU: [ville/région]
PERSONA_REVENU: [estimation revenus]
PERSONA_BUDGET: [budget max estimé pour une prestation]
PERSONA_HORIZON: [horizon temporel de son objectif]
PERSONA_DISPO: [disponibilité par semaine estimée]
PERSONA_CANAUX: [réseau1, réseau2, réseau3]
PERSONA_CITATION: [sa phrase typique entre guillemets, en première personne, très précise]
EMPATHIE_PENSE: [ce qu'il pense profondément, ses peurs et doutes]
EMPATHIE_ENTEND: [ce qu'il entend de son entourage]
EMPATHIE_VOIT: [ce qu'il observe chez ses pairs/concurrents]
EMPATHIE_DIT: [ce qu'il dit à voix haute mais avec ambivalence]
JTBD: [formule JTBD : "Quand... je veux... pour..."]
PERSONA_FRUSTRATIONS: [frustration1|frustration2|frustration3]
PERSONA_OBJECTIFS: [objectif1|objectif2|objectif3]
PERSONA_OBJECTIONS: [objection1|objection2|objection3]
PERSONA_DECLENCHEUR_ACHAT: [description précise du moment déclencheur]
COHERENCE_SCORE: [note de 0 à 100 selon la précision et cohérence des réponses]
COHERENCE_OK: [point fort 1|point fort 2|point fort 3]
COHERENCE_WARN: [point à améliorer 1|point à améliorer 2]
SYNTHESE: [synthèse narrative en 3 phrases de ce persona]

IMPORTANT : Respecte exactement ce format. Utilise des réponses précises et incarnées basées sur les réponses. Sois exigeant sur la cohérence.`;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendConvMessage(); }
  };

  const currentBloc = convStep < 3 ? 'Portrait humain' : convStep < 6 ? "Psychologie & carte d'empathie" : 'Déclencheur & JTBD';

  return (
    <div className="mp">
      <style>{CSS}</style>

      {/* PROGRESS */}
      <div className="mp-progress">
        <div className="mp-progress-fill" style={{width:`${progress}%`}}></div>
      </div>

      {/* ── FORMATION ── */}
      {phase === 'formation' && (
        <div className="mp-formation">
          {FORMATION.map((part, idx) => (
            idx <= formationStep && (
              <div key={idx} className="mp-part">
                <div className="mp-part-num">{part.num}</div>
                <h2>{part.titre}</h2>
                {part.content()}
              </div>
            )
          ))}

          <div className="mp-nav-btns">
            {formationStep > 0 && (
              <button className="mp-btn-secondary" onClick={() => setFormationStep(s => s - 1)}>
                ← Précédent
              </button>
            )}
            <div style={{flex:1}}/>
            {formationStep < FORMATION.length - 1 ? (
              <button className="mp-btn-primary" onClick={() => setFormationStep(s => s + 1)}>
                Partie suivante
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            ) : (
              <button className="mp-btn-primary" onClick={() => setPhase('quiz')}>
                Valider mes connaissances
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            )}
          </div>
        </div>
      )}

      {/* ── QUIZ ── */}
      {phase === 'quiz' && (
        <div className="mp-quiz">
          <div className="mp-part-num" style={{marginBottom:20}}>Quiz de validation</div>
          <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(20px,2.5vw,26px)',color:'#173B34',marginBottom:24}}>
            Vérifions que les bases sont bien là.
          </h2>

          {QUIZ.map((q, qi) => (
            <div key={qi} className="mp-quiz-q">
              <div className="mp-quiz-q-text">{qi + 1}. {q.q}</div>
              <div className="mp-quiz-options">
                {q.opts.map((opt, oi) => {
                  let cls = 'mp-quiz-opt';
                  if (quizSubmitted) {
                    if (oi === q.correct) cls += ' correct';
                    else if (quizAnswers[qi] === oi) cls += ' wrong';
                  } else if (quizAnswers[qi] === oi) cls += ' selected';
                  return (
                    <div key={oi} className={cls}
                      onClick={() => !quizSubmitted && setQuizAnswers(a => ({...a, [qi]: oi}))}>
                      {opt}
                    </div>
                  );
                })}
              </div>
              {quizSubmitted && (
                <div className={`mp-quiz-feedback ${quizAnswers[qi] === q.correct ? 'ok' : 'ko'}`}>
                  {quizAnswers[qi] === q.correct ? '✅ ' : '❌ '}{q.feedback}
                </div>
              )}
            </div>
          ))}

          {error && <div style={{color:'#DC2626',fontSize:13,marginBottom:16}}>{error}</div>}

          <div className="mp-nav-btns">
            <button className="mp-btn-secondary" onClick={() => setPhase('formation')}>← Revoir le cours</button>
            {!quizSubmitted ? (
              <button className="mp-btn-primary" onClick={submitQuiz}>Valider mes réponses</button>
            ) : quizOk ? (
              <button className="mp-btn-primary" onClick={() => setPhase('conversation')}>
                Parfait, on démarre avec Clara
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="#F6F2EC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            ) : (
              <div style={{display:'flex',gap:10}}>
                <button className="mp-btn-secondary" onClick={retryQuiz}>Réessayer</button>
                <button className="mp-btn-primary" onClick={() => setPhase('conversation')}>
                  Continuer quand même →
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── CONVERSATION ── */}
      {phase === 'conversation' && (
        <div className="mp-conv">
          {/* Dots de progression */}
          <div className="mp-step-indicator">
            <div className="mp-step-dots">
              {QUESTIONS_CONV.map((_, i) => (
                <div key={i} className={`mp-step-dot ${i < convStep ? 'done' : i === convStep ? 'active' : ''}`}/>
              ))}
            </div>
            Question {Math.min(convStep + 1, 10)} / 10 · {currentBloc}
          </div>

          <div className="mp-messages">
            {convMessages.map((msg, i) => (
              <div key={i} className={`mp-msg ${msg.role === 'assistant' ? 'clara' : 'user'}`}>
                <div className="mp-msg-avatar">
                  {msg.role === 'assistant' ? 'C' : '✎'}
                </div>
                <div className="mp-msg-bubble" style={{whiteSpace:'pre-wrap'}}>
                  {msg.content}
                </div>
              </div>
            ))}
            {convLoading && (
              <div className="mp-msg clara">
                <div className="mp-msg-avatar">C</div>
                <div className="mp-msg-bubble" style={{color:'#AAA'}}>Clara réfléchit...</div>
              </div>
            )}
            <div ref={chatEndRef}/>
          </div>

          {error && <div style={{color:'#DC2626',fontSize:13,marginBottom:12}}>{error}</div>}

          <div className="mp-input-wrap">
            <textarea
              value={convInput}
              onChange={e => setConvInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Écris ta réponse à Clara"
              rows={2}
              disabled={convLoading}
            />
            <button className="mp-send-btn" onClick={sendConvMessage} disabled={convLoading || !convInput.trim()}>
              Envoyer
            </button>
          </div>
        </div>
      )}

      {/* ── DONE : FICHE ── */}
      {phase === 'done' && (
        <div>
          <FichePersonaV2 synthese={synthese} />
          <div className="mp-nav-btns" style={{marginTop:24}}>
            <button className="mp-btn-secondary" onClick={() => { setPhase('conversation'); setConvMessages([]); setConvStep(0); setSynthese(''); }}>
              Recommencer
            </button>
            <button className="mp-btn-primary" onClick={() => onValidate(synthese)}>
              Valider et continuer →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
